import { useState, useEffect, useRef, useMemo, useCallback  } from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2, Grid, Box, CardMedia, IconButton, FormControl } from '@mui/material'
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import MyTextInput from '../../../components/inputs/MyTextInput';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import MyAutoCompleteJavier from '../../../components/inputs/MyAutoCompleteJavier';
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import MyDateTimePicker from '../../../components/inputs/MyDateTimePicker';
import DieselTankSlider from '../../Diesel/fuelUp/components/DieselTankSlider.jsx';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import axios from 'axios';
import moment from 'moment-timezone';

import DeleteIcon from "@mui/icons-material/Delete";
import { ConstructionOutlined } from '@mui/icons-material';

function CrearEditarOxxo({ open, onClose, refresh, carga, isEditing, isDividing, isMoving }) {

    const normalizarFotos = (fotos) => {
        if (!fotos) return [];

        let fotosArray = fotos;

        if (typeof fotos === 'string') {
            try {
            fotosArray = JSON.parse(fotos);
            } catch {
             fotosArray = fotos
                .split('},{')
                .map((f, i, arr) => {
                if (i > 0) f = '{' + f;
                if (i < arr.length - 1) f = f + '}';
                return JSON.parse(f);
                });
            }
        }

        if (!Array.isArray(fotosArray)) {
            fotosArray = [fotosArray];
        }

        return fotosArray
            .filter(f => f?.ruta)
            .map(f => ({
            id: f.id,
            ruta: f.ruta,
            nombre: f.nombre,
            file: null,
            preview: `https://apifuncionesgenerales.ebtapps.com/img/${f.ruta.replace(/\\/g, '/')}`,
            _status: 'existing',
            }));
    };

    const normalizarPdf = (pdf) => 
    {
        if (!pdf) return null;

        if (typeof pdf === 'object' && (pdf.nombre || pdf.ruta)) {
            return {
            id: pdf.id || null,
            nombre: pdf.nombre || (typeof pdf.ruta === 'string' ? pdf.ruta.split('/').pop() : 'Archivo.pdf'),
            ruta: pdf.ruta || null,
            file: null,
            _status: 'existing',
            };
        }

        if (typeof pdf === 'string') {
            return {
            id: null,
            nombre: pdf.split('/').pop(),
            ruta: pdf,
            file: null,
            _status: 'existing',
            };
        }

        return null;
    };

    const eliminarFoto = (foto, values, setFieldValue) => 
    {
        if (foto._status === 'new') {
            setFieldValue(
            'fotos',
            values.fotos.filter(f => f !== foto)
            );
            return;
        }

        const updated = values.fotos.map(f =>
            f === foto ? { ...f, _status: 'deleted' } : f
        );

        setFieldValue('fotos', updated);
    };

    //Función para formatear la fecha
    const formatDate = (date) => {
        if (!date) return ""; 

        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        //const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`; // Construir el formato
    
        return formattedDateTime;
    };

    const validationSchema = Yup.object({
        fecha: Yup.string()
        .nullable()
        .test('fecha-required', 'La fecha es obligatoria', function(value) {
        const { isDividing, isMoving } = this.options.context;
        // Requerida solo si NO es dividir ni mover
        if (!isDividing && !isMoving && !value) {
            return this.createError({ message: 'La fecha es obligatoria' });
        }
        return true;
        }),

        consumoLitros: Yup.number()
        .transform((value, originalValue) => {
            if (typeof originalValue === 'string') {
            const cleaned = originalValue.replace(/[^0-9.,-]/g, '').replace(',', '.');
            return cleaned === '' ? undefined : parseFloat(cleaned);
            }
            return value;
        })
        .typeError('Debe ser un número válido')
        .test('consumo-required', function(value) {
            const { isMoving } = this.options.context;

            if (!isMoving) {
            if (value === undefined || value === null || value === '') {
                return this.createError({ message: 'El consumo en litros es obligatorio' });
            }
            if (value < 0) {
                return this.createError({ message: 'El consumo en litros no puede ser negativo' });
            }
            if (value === 0) {
                return this.createError({ message: 'El consumo en litros debe ser mayor que 0' });
            }
            } else {
            if (value !== undefined && value !== null && value < 0) {
                return this.createError({ message: 'El consumo en litros no puede ser negativo' });
            }
            }

            return true;
        }),

        noEconomico: Yup.string().required('El número económico es obligatorio'),

        grupo: Yup.string().required('El grupo es obligatorio'),

        cliente: Yup.string().required('El cliente es obligatorio'),
    });

    const initialValues = 
    isDividing
    ? 
    {
        fecha: carga?.fecha ? moment(formatDate(carga.fecha), 'MM/DD/YY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,
        noEconomico: '',
        cliente: '',
        grupo: '',
        consumoPesos: carga?.consumoPesos || '',
        consumoLitros: '',
        usuario: Cookies.get('ebt_nombre'),
        fotos: carga?.fotos ? normalizarFotos(carga.fotos) : [],
        producto: 'Diesel',
        pdf: null,
        orden: '',
        ubicacion: '',
        destino: '',
        nivelDiesel: '',
        comentario: '',
    }
    : isMoving
    ? {
        fecha: carga?.fecha ? moment(formatDate(carga.fecha), 'MM/DD/YY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,
        noEconomico: '',
        cliente: '',
        grupo: '',
        consumoPesos: carga?.consumoPesos || '',
        consumoLitros: carga?.consumoLitros || '',
        producto: 'Diesel',
        usuario: Cookies.get('ebt_nombre'),
        fotos: carga?.fotos ? normalizarFotos(carga.fotos) : [],
        pdf: null,
        orden: '',
        ubicacion: '',
        destino: '',
        nivelDiesel: '',
        comentario: '',
    }
    : 
    {
        fecha: carga?.fecha ? moment(formatDate(carga.fecha), 'MM/DD/YY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,
        noEconomico: carga?.noEconomico || '',
        cliente: carga?.cliente || '',
        grupo: carga?.grupo || '',
        consumoPesos: carga?.consumoPesos || '',
        consumoLitros: carga?.consumoLitros || '',
        producto: 'Diesel',
        usuario: Cookies.get('ebt_nombre'),
        fotos: carga?.fotos ? normalizarFotos(carga.fotos) : [],
        pdf: carga?.pdf ? normalizarPdf(carga.pdf) : null,
        orden: carga?.orden || '',
        ubicacion: carga?.ubicacion || '',
        destino: carga?.destino || '',
        nivelDiesel: carga?.nivelDiesel || '',
        comentario: '',
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        
        const payload = {  
            fecha: values.fecha,
            noEconomico: values.noEconomico,
            cliente: values.cliente,
            grupo: values.grupo,
            consumoPesos: values.consumoPesos,
            consumoLitros: values.consumoLitros,
            producto: values.producto,
            usuario: values.usuario,
            orden: values.orden,
            ubicacion: values.ubicacion,
            destino: values.destino,
            nivelDiesel: values.nivelDiesel,
            comentario: values.comentario
        };

        // Validar formato
        if(!isMoving && !isDividing && payload.orden != '')
        {
            if(!/^\d+$/.test(payload.orden)) 
            {
                Swal.fire({
                    icon: 'error',
                    title: '¡Error!',
                    text: 'El número de orden no tiene un formato válido.',
                    target: document.getElementById('dialog1')
                });
                setSubmitting(false);
                return;
            }

            let ordenExiste = false;
            let errorEnConsulta = false;
            let continuarConError = false;

            try 
            {

                const response = await myApi.get(`/fuel_report/getOrden?orden=${payload.orden}`);

                if(response.data?.success && response.data.data?.length > 0) 
                {
                    ordenExiste = true;
                    console.log('La orden existe:', response.data.data[0].id);
                } 
                else 
                {
                    // Orden no encontrada aunque se pudo consultar correctamente
                    console.log('La orden no existe');
                    Swal.fire({
                        icon: 'error',
                        title: '¡Orden no encontrada!',
                        text: 'La orden no existe en el sistema. Por favor, revisa el número de orden.',
                        target: document.getElementById('dialog1')
                    });
                    setSubmitting(false);
                    return;
                }
            } 
            catch(error) 
            {
                // Error al consultar McLeod → preguntar si desea continuar
                errorEnConsulta = true;
                console.error('Error al consultar McLeod:', error);
            }

            // Si hubo error al consultar, preguntar si desea continuar
            if (errorEnConsulta) 
            {
                const result = await Swal.fire({
                    icon: 'warning',
                    title: 'No se pudo validar la orden',
                    text: 'No se pudo consultar McLeod. ¿Desea continuar de todos modos?',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, continuar',
                    cancelButtonText: 'No, cancelar',
                    target: document.getElementById('dialog1')
                });

                if (!result.isConfirmed) 
                {
                    setSubmitting(false);
                    return;
                } 
                else 
                {
                    continuarConError = true;
                }
            }

            // Agregar comentario si se decidió continuar con error
            if (continuarConError) 
            {
                values.comentario = 'Se guardó sin validar contra McLeod';
            }
        }

        const formData = new FormData();

        // Campos normales
        /*
        if (values.fecha) 
        {
            formData.append('fecha', values.fecha);
        }
        formData.append('noEconomico', values.noEconomico);
        formData.append('cliente', values.cliente);
        formData.append('grupo', values.grupo);
        formData.append('consumoPesos', values.consumoPesos ?? '');
        formData.append('consumoLitros', values.consumoLitros);
        formData.append('producto', values.producto);
        formData.append('usuario', values.usuario);

        // Fotos
        values.fotos.forEach((foto, index) => {
            formData.append('fotos', foto.file);
            // o si quieres nombre explícito:
            // formData.append(`fotos[${index}]`, foto.file);
        });
        */

        Object.entries(values).forEach(([k, v]) => {
            if (k !== 'fotos' && k !== 'pdf') formData.append(k, v);
        });

        const fotosNuevas = values.fotos.filter(f => f._status === 'new');

        const fotosEliminar = values.fotos
        .filter(f => f._status === 'deleted' && f.id)
        .map(f => f.id);

        fotosNuevas.forEach(f => {
            formData.append('fotos', f.file);
        });

        formData.append('fotosEliminar', JSON.stringify(fotosEliminar));

        if (values.pdf?._status === 'new') 
        {
            formData.append('file', values.pdf.file);
        }

        if (values.pdf?._status === 'deleted') 
        {
            formData.append('pdfEliminar', '1');
        }

        try 
        {
            if (isDividing) 
            {
                if (payload.consumoLitros >= carga.consumoLitros) 
                {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Error en división',
                        text: 'El consumo en litros debe ser menor al de la carga original',
                        target: document.getElementById('dialog1')
                    });
                    return;
                }

                let responseDividir = await myApi.put(`/cargasFuel/dividirOxxo/${carga.id}`, payload);

                if(responseDividir.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga dividida',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al dividir carga',
                        text: responseDividir.data.data || 'Ocurrió un error desconocido',
                    });

                    console.error('Error de API:', responseDividir.data);
                }
            } 
            else if (isMoving) 
            {
                let responseMover = await myApi.put(`/cargasFuel/moverOxxo/${carga.id}`, payload);

                if(responseMover.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga movida',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al mover carga',
                        text: responseMover.data.data || 'Ocurrió un error desconocido',
                        target: document.getElementById('dialog1')
                    });

                    console.error('Error de API:', responseMover.data);
                }
            } 
            else if (isEditing) 
            {
                //let responseEditar = await myApi.put(`/cargasFuel/editarOxxo/${carga.id}`, payload);
                let responseEditar = await myApi.put(`/cargasFuel/editarOxxo/${carga.id}`, formData);

                if(responseEditar.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga editada',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseEditar.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseEditar.data.data || 'Ya existe una carga con esa fecha y unidad',
                            target: document.getElementById('dialog1')
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al editar carga',
                            text: responseEditar.data.data || 'Ocurrió un error desconocido',
                            target: document.getElementById('dialog1')
                        });
                    }

                    console.error('Error de API:', responseEditar.data);
                }
            } 
            else 
            {
                //let responseCrear = await myApi.post('/cargasFuel/crearOxxo', payload);
                let responseCrear = await myApi.post('/cargasFuel/crearOxxo', formData);

                if(responseCrear.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga creada',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseCrear.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseCrear.data.data || 'Ya existe una carga con esa fecha y unidad',
                            target: document.getElementById('dialog1')
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al crear carga',
                            text: responseCrear.data.data || 'Ocurrió un error desconocido',
                            target: document.getElementById('dialog1')
                        });
                    }

                    console.error('Error de API:', responseCrear.data);
                }
            }
        } 
        catch (error) 
        {
            Swal.fire({
                icon: 'error',
                title: 'Error del servidor',
                text: error.response?.data?.message || error.message || 'Ocurrió un error desconocido',
            });
            console.error('Error saving charge:', error);
        }
    };

    const [tractoresEBT, setTractoresEBT] = useState([]);
    const [tractoresTEDEL, setTractoresTEDEL] = useState([]);
    const [cajasEBT, setCajasEBT] = useState([]);
    const [cajasTEDEL, setCajasTEDEL] = useState([]);

    const fetchAllUnidades = useCallback(async () => 
    {
        const statuses = ['A', 'I', 'S'];
        const companies = ['EBT', 'TEDEL'];

        try {
            const tractorRequests = companies.flatMap(company =>
                statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trucks/',
                        { company, status, tractor: null }
                    )
                )
            );

            const cajaRequests = companies.flatMap(company =>
                statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trailers/',
                        { company, status, trailer: null }
                    )
                )
            );

            const [tractorResponses, cajaResponses] = await Promise.all([
                Promise.all(tractorRequests),
                Promise.all(cajaRequests)
            ]);

            const tractoresRaw = tractorResponses.flatMap(r => r.data);
            const cajasRaw = cajaResponses.flatMap(r => r.data);

            const tractoresEBT = new Map();
            const tractoresTEDEL = new Map();
            const cajasEBT = new Map();
            const cajasTEDEL = new Map();

            tractoresRaw.forEach(t => {
                if (!t.tractor) return;

                const item = { value: t.tractor, label: t.tractor };

                if (t.company === 'EBT') {
                    tractoresEBT.set(t.tractor, item);
                } else if (t.company === 'TEDEL') {
                    tractoresTEDEL.set(t.tractor, item);
                }
            });

            cajasRaw.forEach(c => {
                if (!c.trailer) return;

                const item = { value: c.trailer, label: c.trailer };

                if (c.company === 'EBT') {
                    cajasEBT.set(c.trailer, item);
                } else if (c.company === 'TEDEL') {
                    cajasTEDEL.set(c.trailer, item);
                }
            });

            setTractoresEBT([...tractoresEBT.values()]);
            setTractoresTEDEL([...tractoresTEDEL.values()]);
            setCajasEBT([...cajasEBT.values()]);
            setCajasTEDEL([...cajasTEDEL.values()]);

        } catch (error) {
            console.error('Error cargando unidades', error);
        }
    }, []);

    useEffect(() => {
        fetchAllUnidades();
    }, [fetchAllUnidades]);

    const isOnlyDividing = isDividing && !isEditing && !isMoving;
    const isOnlyMoving = isMoving && !isEditing && !isDividing;

    return (
        <Dialog id="dialog1" open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{
  isDividing
    ? 'Dividir Carga de API de OXXO'
    : isMoving
    ? 'Mover Carga de API de OXXO'
    : isEditing
      ? 'Editar Carga Manual de OXXO'
      : 'Crear Carga Manual de OXXO'
}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={{
                        ...initialValues,
                        isDividing,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    context={{ isDividing, isMoving, isEditing }}
                >
                    {({ isSubmitting, handleSubmit, errors, touched, values, setFieldValue }) => {

                        const catalog =
                            values.grupo === 'TRACTORES' && values.cliente?.includes('EBT')
                                ? tractoresEBT
                                : values.grupo === 'TRACTORES' && values.cliente?.includes('TEDEL')
                                ? tractoresTEDEL
                                : values.grupo === 'CAJAS' && values.cliente?.includes('EBT')
                                ? cajasEBT
                                : values.grupo === 'CAJAS' && values.cliente?.includes('TEDEL')
                                ? cajasTEDEL
                                : [];

                    return (
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Grid2 container spacing={2}>
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyDateTimePicker
                                        name="fecha"
                                        label="FECHA"
                                        error={touched.fecha && Boolean(errors.fecha)}
                                        helperText={touched.fecha && errors.fecha}
                                    />
                                    {errors.fecha && touched.fecha ? (
                                        <div style={{ color: '#D3302F', fontSize: '12px' }}>{errors.fecha}</div>
                                    ) : null}
                                </Grid2>
                                )}
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="grupo"
                                        label="GRUPO"
                                        options={[
                                            { value: 'TRACTORES', label: 'TRACTORES' },
                                            { value: 'CAJAS', label: 'CAJAS' },
                                        ]}
                                        onChange={() => setFieldValue('noEconomico', null)}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="cliente"
                                        label="CLIENTE"
                                        options={[
                                            { value: 'EBT FREIGHT SA DE CV', label: 'EBT FREIGHT SA DE CV' },
                                            { value: 'TEDEL TRUCKING SA DE CV', label: 'TEDEL TRUCKING SA DE CV' },
                                        ]}
                                        onChange={() => setFieldValue('noEconomico', null)}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoCompleteJavier
                                        name="noEconomico"
                                        label="UNIDAD"
                                        options={catalog} 
                                        key={`noeconomico-${values.grupo}-${values.noEconomico}`} 
                                    />
                                </Grid2>
                                {!isOnlyDividing && !isOnlyMoving && (
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyNumberInput
                                        name="consumoPesos"
                                        label="CONSUMO EN PESOS"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyMoving && (
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyNumberInput
                                        name="consumoLitros"
                                        label="CONSUMO EN LITROS"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="orden"
                                        label="ORDEN"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="ubicacion"
                                        label="UBICACIÓN"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="destino"
                                        label="DESTINO"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{xs: 12, sm: 12}}>
                                    <FormControl fullWidth>
                                        <Field name="nivelDiesel">
                                            {({ field }) => (
                                            <DieselTankSlider
                                                label="Nivel de Diésel"
                                                value={values.nivelDiesel}
                                                onChange={(newValue) => {
                                                const valueToLabelMap = {
                                                    0: "EMPTY",
                                                    1: "1/16",
                                                    2: "1/8",
                                                    3: "3/16",
                                                    4: "1/4",
                                                    5: "5/16",
                                                    6: "3/8",
                                                    7: "7/16",
                                                    8: "1/2",
                                                    9: "9/16",
                                                    10: "5/8",
                                                    11: "11/16",
                                                    12: "3/4",
                                                    13: "13/16",
                                                    14: "7/8",
                                                    15: "15/16",
                                                    16: "FULL",
                                                };
                                                let nuevoValor = valueToLabelMap[newValue];
                                                setFieldValue('nivelDiesel', nuevoValor);
                                                }}
                                            />
                                            )}
                                        </Field>
                                    </FormControl>
                                </Grid2>
                                )}
                                {(isEditing || (!isDividing && !isMoving)) && (
                                    <Grid2 size={{ xs: 12, sm: 4 }}>
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            style={{ display: "none" }}
                                            id="upload-pdf-form"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setFieldValue('pdf', {
                                                        id: null,
                                                        nombre: file.name,
                                                        file,
                                                        _status: 'new',
                                                    });
                                                }
                                                e.target.value = null; // reset input
                                            }}
                                        />
                                        <label htmlFor="upload-pdf-form">
                                            <Button
                                                variant="outlined"
                                                component="span"
                                                fullWidth
                                                color="secondary"
                                            >
                                                {values.pdf && values.pdf._status !== 'deleted' ? 'Reemplazar PDF' : 'Agregar PDF'}
                                            </Button>
                                        </label>
                                    </Grid2>
                                )}
                                {values.pdf && values.pdf._status !== 'deleted' && (
                                    <Grid2 size={{ xs: 12, sm: 12 }}>
                                        <Box position="relative" p={1} border="1px solid #ccc" borderRadius={2} display="flex" alignItems="center" justifyContent="space-between">
                                        <span>{values.pdf.nombre}</span>
                                        <IconButton
                                            onClick={() => setFieldValue('pdf', { ...values.pdf, _status: 'deleted' })}
                                            sx={{ backgroundColor: "rgba(255,255,255,0.7)" }}
                                        >
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                        </Box>
                                    </Grid2>
                                )}
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        capture="environment"
                                        multiple
                                        style={{ display: "none" }}
                                        id="upload-photo-form"
                                        onChange={(e) => {
                                        const files = Array.from(e.target.files);

                                        if (files.length > 0) 
                                        {
                                            const newFotos = files.map(file => ({
                                                id: null,
                                                ruta: null,
                                                nombre: file.name,
                                                file,
                                                preview: URL.createObjectURL(file),
                                                _status: 'new',
                                            }));

                                            setFieldValue('fotos', [...values.fotos, ...newFotos]);
                                        }

                                        // 🔑 CLAVE para iOS
                                        e.target.value = null;
                                        }}
                                    />
                                    {!isOnlyDividing && !isOnlyMoving &&(
                                    <label htmlFor="upload-photo-form">
                                        <Button
                                        variant="outlined"
                                        component="span"
                                        fullWidth
                                        color="primary"
                                        >
                                        Agregar foto
                                        </Button>
                                    </label> 
                                    )}
                                </Grid2>
                                {values.fotos.length > 0 && (
                                    <Grid2 size={{ xs: 12, sm: 12 }}>
                                        <Grid2 container spacing={2}>
                                            {values.fotos.filter(f => f._status !== 'deleted').map((foto, idx) => (
                                                <Grid2 item xs={6} sm={4} key={idx}>
                                                    <Box position="relative">
                                                        <CardMedia
                                                        component="img"
                                                        height="140"
                                                        image={foto.preview}
                                                        sx={{ borderRadius: 2 }}
                                                        />

                                                        {/* Indicador de foto existente o nueva */}
                                                        <Box sx={{ position: 'absolute', bottom: 8, left: 8, backgroundColor: 'rgba(0,0,0,0.5)', color: '#fff', px: 1, borderRadius: 1, fontSize: 10 }}>
                                                            {foto.id ? 'Existente' : 'Nueva'}
                                                        </Box>

                                                        <IconButton
                                                        onClick={() => eliminarFoto(foto, values, setFieldValue)}
                                                        sx={{
                                                            position: "absolute",
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor: "rgba(255,255,255,0.7)",
                                                        }}
                                                        >
                                                        <DeleteIcon color="error" />
                                                        </IconButton>
                                                    </Box>
                                                </Grid2>
                                            ))}
                                        </Grid2>
                                    </Grid2>
                                )}

                                <DialogActions style={{ justifyContent: 'flex-end' }}>
                                    <Button type="submit" disabled={isSubmitting} variant="contained" color="primary">
                                        Guardar
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarOxxo